<template>
  <div class="wrapper">
    <CustomTitle zh="媒体的报道" en="MEDIA REPORT" />
    <div class="media-story">
      <div
        ref="imageBox"
        class="report-image animated"
        :style="{ backgroundImage: `url(${reportImages[activeIndex]})` }"
      ></div>
      <swiper :options="swiperOption" class="media-swiper" ref="mySwiper">
        <swiper-slide v-for="(info, index) of swiperInfo" :key="index">
          <div style="padding: 0 30px">
            <h2>{{ info.title }}</h2>
            <p class="detail">{{ info.detail }}</p>
            <div class="button-wrapper"><BaseButton :href="info.href" /></div>
          </div>
        </swiper-slide>
        <div
          class="swiper-pagination swiper-pagination-bullets"
          slot="pagination"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import "animate.css/animate.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import CustomTitle from "../components/common/CustomTitle";
import BaseButton from "../components/common/BaseButton";

export default {
  components: {
    swiper,
    swiperSlide,
    CustomTitle,
    BaseButton,
  },
  data() {
    return {
      activeIndex: 0,
      swiperOption: {
        autoplay: {
          delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.activeIndex = this.swiper.activeIndex;
            this.imageBox.classList.add("zoomIn");
            setTimeout(() => {
              this.imageBox.classList.remove("zoomIn");
            }, 300);
          },
        },
      },

      swiperInfo: [
        {
          title: "网易新闻",
          detail: `LXBIRD留学鸟获腾讯教育回响中国2021年度影响力留学服务品牌大奖`,
          href: "https://www.163.com/dy/article/GREBKAIA05169NSC.html",
        },
        {
          title: "腾讯教育",
          detail: `LXBIRD留学鸟CEO陈尧星：新服务模式打造客户服务新体验`,
          href: "https://page.om.qq.com/page/OTNfS12cvFt7M6m-Ubfrcicg0",
        },
        {
          title: "动点科技",
          detail: `其实这个领域的市场前景还远未被开发，留学生群体的巨大需求让创业者看到了机会。
          香不香港团队也在逐步摸索开荒的过程中。未来如果发展乐观的话，
          做成一个针对留学生市场的 58 同城也是可能的事情。`,
          href: "https://cn.technode.com/post/2015-11-26/hknohk/",
        },
        {
          title: "猎云网",
          detail: `香不香港：主打香港留学生落地生活服务，要做留学界的“58同城”`,
          href: "https://www.lieyunwang.com/archives/239405",
        },
        // {
        //   title: "创业邦",
        //   detail: `利用留学后端服务平台慢慢在留学生市场建立品牌和口碑，
        //   前端申请服务更能在高度同质化的市场中形成竞争性优势，让准备申请的学生更加信任更容易选择前端的服务。`,
        //   href: "https://www.cyzone.cn/article/148357.html"
        // },
        {
          title: "创客猫",
          detail: `如今在普遍的互联网创业项目内，香不香港团队更多的是脚踏实地去服务留学生群体，
          而不是在做一个很宏大的概念或者一个很诱人的故事`,
          href: "http://www.chuangkem.com/archives/104437",
        },
        {
          title: "团结香港基金",
          detail: `目標衝出香港及內地，走海外，未來將打算設立「澳不澳洲」，「英不英國」等留學生的熱門目的地，打造「留學生共享生活空間」`,
          href: `https://www.ourhkfoundation.org.hk/zh-hant/video/90/%E5%9C%98%E7%B5%90%E9%A6%99%E6%B8%AF%E5%9F%BA%E9%87%91/%E3%80%8A%E9%A6%99%E6%B8%AF%E4%BA%BA%EF%BC%8E%E9%A6%99%E6%B8%AF%E6%83%85%E3%80%8B%E6%B8%AF%E6%BC%82%E5%89%B5%E6%A5%AD%E5%A4%A2`,
        },
      ],
    };
  },
  computed: {
    reportImages() {
      return [
        require("../assets/media-pic-6.png"),
        require("../assets/media-pic-7.png"),
        require("../assets/media-pic-2.png"),
        require("../assets/media-pic-1.png"),
        // require("../assets/media-pic-3.png"),
        require("../assets/media-pic-4.png"),
        require("../assets/media-pic-5.svg"),
      ];
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    imageBox() {
      return this.$refs.imageBox;
    },
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
};
</script>

<style lang="scss">
.media-swiper {
  margin-right: 110px;
  & .swiper-pagination {
    text-align: right;
  }

  & .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background-color: #9a9a9a;
  }

  & .swiper-pagination-bullet-active {
    width: 16px;
    height: 6px;
    background-color: #3a8df5;
    border-radius: 3px;
  }
}
</style>

<style lang="scss" scoped>
.wrapper {
  width: 1279px;
  margin: 0 auto;
}
.media-story {
  display: flex;

  .report-image {
    flex-basis: 523px;
    height: 356px;
    flex-shrink: 0;
    margin-right: 116px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    animation-duration: 0.3s;
  }

  & .detail {
    color: #7a7a7a;
  }

  & .button-wrapper {
    padding-top: 20px;
    text-align: right;
  }
}
</style>
